<template>
  <div id="legalNotice" class="d-flex flex-column justify-content-around align-items-left" v-if="legalNoticeLg.lg1.length > 0" v-html="rawHtml(legalNoticeLg[currentLg])">
  </div>
</template>

<script>
export default {
  name: 'MercureRatesHorizontalV1LegalNoticeCenter',
  props: {
    legalNoticeLg: Object,
    currentLg: ''
  },
  methods: {
    rawHtml (value) {
      return value
    }
  }
}
</script>


<style lang="scss" scoped>
  $srcWidth: 1920;
  $srcHeight: 1200;
  @import "../../../../_ibis.scss";

  #legalNotice {
    font-family: "Helvetica-Roman";
    @include fontSize(25);
    line-height: 1.2em;

    position: absolute;
    bottom: 0.5em;
    @include widthPercent(904);
    @include heightPercent(96);
    justify-content: space-evenly!important;

  #bloc2, #bloc3 {
  //margin-top: 0.8rem;
  }
  }

</style>


// WEBPACK FOOTER //
// src/components/ibis/rates/horizontal/v1/services/legalNoticeCenter.vue